import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Header, Grid, Modal, Button, Icon } from "semantic-ui-react";
import Field from "../misc/Field";
import Flagship from "../../core/flagship";

class TaskPickModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onChange = this.onChange.bind(this);
    this.saveAndExit = this.saveAndExit.bind(this);
  }

  getInitialState() {
    return {
      task: null
    };
  }

  componentDidUpdate() {
    if (this.props.open) {
      const input = ReactDOM.findDOMNode(
        document.querySelector(".task-selection-dropdown input.search")
      );
      if (input !== null) input.focus();
    }
  }

  onChange(e, task) {
    this.setState({ task });
  }

  saveAndExit() {
    this.props.onSelectTask(this.state.task);
  }

  render() {
    return (
      <Modal
        open={this.props.open}
        onClose={this.props.cancelSelect}
        closeIcon
        width={500}
      >
        <Header icon="list" content="Choose Category" />
        <Modal.Content>
          <div>
            <Grid>
              <Grid.Column width={16}>
                <div className="task-selection-dropdown">
                  <Field
                    type="select"
                    openOnFocus={true}
                    onChange={this.onChange}
                    options={Flagship.config.timeTrackerTasks}
                    value={this.state.task}
                  />
                </div>

                <small style={{ color: "#666" }}>
                  Select the service or activity that this time falls under.
                </small>
              </Grid.Column>
            </Grid>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.saveAndExit}>
            <Icon name="tasks" /> Select Category
          </Button>
          <Button color="grey" onClick={this.props.cancelSelect}>
            <Icon name="dont" /> Cancel
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole
  };
}

export default connect(mapStateToProps, null)(TaskPickModal);



// WEBPACK FOOTER //
// ./src/components/modals/TaskPickModal.js